
const except_column = ['PTMIDGKD_2','PTMIEMSY'];

const createStatObject = (id,bodylist,data,statPrefix,TotalCnt)  => (
    
    {
    FIDELITY_ID: id,
    FIDELITY_NAME: Object.values(bodylist).filter(content => id === content.FIDELITY_CODE)[0].FIDELITY_NAME,
    ORG_NORMAL: (`${statPrefix}_N` in data.statInfo)  ? isNaN((data.statInfo[`${statPrefix}_N`] / data.statInfo[`${TotalCnt}`] * 100).toFixed(2)) === true ? '-' : (data.statInfo[`${statPrefix}_N`] / data.statInfo[`${TotalCnt}`] * 100).toFixed(2) : ' ',
    ORG_REVIEW: (`${statPrefix}_R` in data.statInfo)  ? isNaN((data.statInfo[`${statPrefix}_R`] / data.statInfo[`${TotalCnt}`] * 100).toFixed(2)) === true ? '-' : (data.statInfo[`${statPrefix}_R`] / data.statInfo[`${TotalCnt}`] * 100).toFixed(2) : ' ',
    ORG_REVIEW_1: except_column.includes(id) ? isNaN((data.statInfo[`${statPrefix}_N`] / data.statInfo[`${TotalCnt}`] * 100).toFixed(2)) === true ? '-' : (data.statInfo[`${statPrefix}_N`] / data.statInfo[`${TotalCnt}`] * 100).toFixed(2) : ' ',
    ORG_REVIEW_2: except_column.includes(id) ? isNaN((data.statInfo[`${statPrefix}_E`] / data.statInfo[`${TotalCnt}`] * 100).toFixed(2)) === true ? '-' : (data.statInfo[`${statPrefix}_E`] / data.statInfo[`${TotalCnt}`] * 100).toFixed(2) : ' ',
    ORG_ERROR: (`${statPrefix}_E` in data.statInfo)  ? isNaN((data.statInfo[`${statPrefix}_E`] / data.statInfo[`${TotalCnt}`] * 100).toFixed(2)) === true ? '-' : (data.statInfo[`${statPrefix}_E`] / data.statInfo[`${TotalCnt}`] * 100).toFixed(2) : ' ', 
    TOTAL_CNT: TotalCnt,
    SEQ: Object.values(bodylist).filter(content => id === content.FIDELITY_CODE)[0].SEQ,
    FIDELITY_TYPE: Object.values(bodylist).filter(content => id === content.FIDELITY_CODE)[0].FIDELITY_TYPE,
    rowSpanValue: except_column.includes(id) ? 2 : 1
});

const generate_fidelity_mng_list = (bodylist,data,searchType) => {
    let datalist = [];

    datalist.push(createStatObject('PTMIBRTD_PTMISEXX',bodylist,data,'CHECK01','TOTAL_CNT1'));
    datalist.push(createStatObject('PTMIAKDTM',bodylist,data,'CHECK02','TOTAL_CNT15'));
    datalist.push(createStatObject('PTMIDGKD',bodylist,data,'CHECK03','TOTAL_CNT3'));
    datalist.push(createStatObject('PTMIDGKD_2',bodylist,data,'CHECK04','TOTAL_CNT16'));
    datalist.push(createStatObject('PTMIDGKD_3',bodylist,data,'CHECK05','TOTAL_CNT4'));
    datalist.push(createStatObject('PTMIARCS',bodylist,data,'CHECK06','TOTAL_CNT5'));
    datalist.push(createStatObject('PTMIEQUI',bodylist,data,'CHECK07','TOTAL_CNT6'));
    datalist.push(createStatObject('PTMIINTP_PTMIINCD',bodylist,data,'CHECK08','TOTAL_CNT17'));
    datalist.push(createStatObject('PTMIEMSY',bodylist,data,'CHECK09','TOTAL_CNT21'));
    datalist.push(createStatObject('PTMIINMN',bodylist,data,'CHECK10','TOTAL_CNT18'));
    datalist.push(createStatObject('PTMIEMRT',bodylist,data,'CHECK11','TOTAL_CNT19'));
    datalist.push(createStatObject('PTMIDCTP_PTMIDCCD',bodylist,data,'CHECK12','TOTAL_CNT20'));
    datalist.push(createStatObject('PTMIOTDTM',bodylist,data,'CHECK13','TOTAL_CNT22'));
    datalist.push(createStatObject('PTMIDCDTM',bodylist,data,'CHECK14','TOTAL_CNT23'));
    datalist.push(createStatObject('PTMIHSDTM',bodylist,data,'CHECK15','TOTAL_CNT24'));

    return datalist

}
export default generate_fidelity_mng_list;